<header class="lp-header" [class.menu-open]="isMenuOpen">
  <div class="container">
    <nav class="lp-nav">
      <a class="nav-brand" href="#">
        <img src="assets/images/dropaddy-logo.svg" alt="DropAddy" class="nav-logo" />
      </a>

      <div class="nav-links d-none d-lg-flex">
        <a href="#features" class="nav-item">Features</a>
        <a href="#app-preview" class="nav-item">App Preview</a>
        <a href="#contact" class="nav-item">Contact</a>
      </div>

      <div class="d-none d-lg-flex">
        <a routerLink="/auth/login" class="btn-admin-login">Login</a>
      </div>

      <button class="hamburger-btn d-lg-none" type="button" (click)="toggleMenu()">
        <div class="hamburger" [class.active]="isMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
    </nav>

    <!-- Mobile Sidebar Menu Overlay -->
    <div class="mobile-menu-overlay d-lg-none" [class.active]="isMenuOpen">
      <div class="mobile-menu-header">
        <img src="assets/images/dropaddy-logo.svg" alt="DropAddy" class="mobile-logo" />
        <button class="close-btn" type="button" (click)="closeMenu()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="mobile-menu-body">
        <ul class="mobile-nav-list">
          <li class="nav-item">
            <a href="#features" class="nav-link" (click)="closeMenu()">Features</a>
          </li>
          <li class="nav-item">
            <a href="#app-preview" class="nav-link" (click)="closeMenu()">App Preview</a>
          </li>
          <li class="nav-item">
            <a href="#contact" class="nav-link" (click)="closeMenu()">Contact</a>
          </li>
        </ul>

        <div class="mobile-auth-section">
          <a routerLink="/auth/login" class="mobile-nav-btn" (click)="closeMenu()">
            Login
          </a>
        </div>
      </div>
    </div>
  </div>
</header>
